import ArrowDownIcon from '@assets/images/arrow-down.svg?react'
import { styled } from '@mui/system'

export const StyledArrowDown = styled(ArrowDownIcon)`
    display: flex;
    align-items: center;
    justify-content: center;
`
